import { skipToken, useQuery } from '@tanstack/react-query';
import { usePublishedContext } from '@/components/views/published/PublishedContext';
import type { Schedule } from '@/lib/api/types/schedules';
import { useGetSchedulesByItemIds } from '@/lib/queries/work-integrations/useGetSchedules';
import { workIntegrationsQueryKeys } from '@/lib/query-keys/work-integrations';

export const useSchedulesQueryWithPublished = (itemId: number, enabled = true) => {
  const publishedContext = usePublishedContext();
  const isPublished = publishedContext !== null;

  const schedulesQuery = useGetSchedulesByItemIds([itemId], undefined, !isPublished && enabled);

  const publishedQuery = useQuery<Record<number, Schedule> | undefined>({
    queryKey: [...workIntegrationsQueryKeys.scheduleByItemId(itemId), 'published'],
    queryFn: skipToken,
    initialData: () => {
      if (!publishedContext) return undefined;
      const schedule = publishedContext.getItemPanelData(itemId)?.schedule;
      return schedule ? { [itemId]: { itemId, ...schedule } } : {};
    },
    enabled: false,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return isPublished ? publishedQuery : schedulesQuery;
};
